import { defineEvent, type EventPayload } from '@nexus/core';
import { z } from 'zod';
import { TENDER_STATUSES } from './types';

// Events carry IDs, never personal data: subscribers load what they need through the public API.

/** A tender was marked as interesting or entered by hand: work on it starts. */
export const tenderMarked = defineEvent('tenders.tender.marked', z.object({ id: z.uuid() }));
export type TenderMarked = EventPayload<typeof tenderMarked>;

export const tenderStatusChanged = defineEvent(
  'tenders.tender.status-changed',
  z.object({ id: z.uuid(), status: z.enum(TENDER_STATUSES) }),
);
export type TenderStatusChanged = EventPayload<typeof tenderStatusChanged>;
